module.exports = __webpack_public_path__ + "img/lock.9f40a250.svg";